import React from 'react';
import classNames from 'classnames';
import bindAll from 'lodash.bindall';
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl';
import embeddedIcon from './embeddedIcon.svg';
import embeddedIconSelected from './embeddedIconSelected.svg';
import "./menu-bar.css";
import PropTypes from 'prop-types';
import {toast} from 'react-hot-toast';
// import {message} from 'antd';

// 新建文件类组件
class AIMenuItem extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleMouseEnter',
            'handleMouseLeaveOuter',
            'handleMouseLeave',
            'handleAIMenu'
        ]);
        this.ref = React.createRef();
        this.state = {
            AIMenuState: false
        }
        this.timer = null
    }

    componentDidMount () {
        if (!('ontouchstart' in window)) {
            this.ref.current.addEventListener(
                'mouseenter',
                this.props.onClickEdit
            );
            this.ref.current.addEventListener(
                'mouseleave',
                this.props.onRequestCloseEdit
            );
        }
    }

    componentWillUnmount () {
        this.ref.current.removeEventListener(
            'mouseenter',
            this.props.onClickEdit
        );
        this.ref.current.removeEventListener(
            'mouseleave',
            this.props.onRequestCloseEdit
        );
    }
    // 点击跳转
    handleAIMenu (type) {
        localStorage.setItem('routerMeunId', type)
        window.location.href = window.location.origin
    }
    handleMouseEnter () {
        clearTimeout(this.timer);
        this.setState({
            AIMenuState: true
        })
    }
    handleMouseLeaveOuter () {
        this.timer = setTimeout(() => {
            this.setState({
                AIMenuState: false
            })
        }, 200);
    }
    handleMouseLeave () {
        this.setState({
            AIMenuState: false
        })
    }
    render () {
        return (
            <div>
                <div
                ref={this.ref}
                className={this.state.AIMenuState ? 'menuBarItemSelect' : 'menuBarItem'}
            >
                <div
                    style={{display: 'flex'}}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeaveOuter}
                >
                    <img
                        className='menuIcon'
                        src={
                            this.state.AIMenuState ?
                                embeddedIconSelected :
                                embeddedIcon
                        }
                        alt="tools"
                    />
                    <span
                        style={{
                            verticalAlign: 'middle',
                            ...(this.state.AIMenuState ?
                                {color: '#3073ff'} :
                                {})
                        }}
                    >
                        {/* AI */}
                        <FormattedMessage
                            defaultMessage="AI"
                            id="meun-item-aiproject"
                        />
                    </span>
                </div>
            </div>
            {this.state.AIMenuState && 
                <div 
                    className="toolboxMenuContainer"
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                >
                    <div
                        className="languageMenuItem"
                        onClick={() => this.handleAIMenu('AIProject')}
                    >
                        <div className="line"></div>
                        {/* TinyML Model */}
                        <FormattedMessage
                            defaultMessage="TinyML Model"
                            id="meun-item-ai-TinyML"
                        />
                    </div>
                    {/* matataChat授权码 */}
                    <div
                        className="languageMenuItem"
                        onClick={() => this.handleAIMenu('matataChatCode')}
                    >
                        <div className="line"></div>
                        <FormattedMessage
                            defaultMessage="Authorization Code"
                            id="meun-item-toolbox-matataChatCode"
                        />
                    </div>
                </div>
            }
            </div>
            
        );
    }
}

export default AIMenuItem;
